module.exports = __webpack_public_path__ + "img/logo-farina-sostenibile.d3eb7971.png";